class ProductCardDynamicPricing {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('click', (e) => {
      const swatch = e.target.closest('[data-variant-id][data-campaign-discount]');
      if (!swatch) return;

      const productCard = swatch.closest('product-card');
      if (!productCard) return;

      const campaignDiscount = parseFloat(swatch.dataset.campaignDiscount) || 0;
      const variantPrice = parseFloat(swatch.dataset.variantPrice) || 0;
      const variantComparePrice = parseFloat(swatch.dataset.variantComparePrice) || 0;

      const hasPromotion = campaignDiscount > 0 && variantComparePrice > 0 && variantComparePrice > variantPrice;

      const variant = {
        price: variantPrice,
        compare_at_price: variantComparePrice
      };

      this.updatePrices(productCard, variant, hasPromotion);
      this.updateBadges(productCard, variant, hasPromotion, swatch);
      this.update30DayPrice(productCard, hasPromotion, swatch);
    });
  }

  updatePrices(productCard, variant, hasPromotion) {
    const priceList = productCard.querySelector('price-list');
    if (!priceList) return;

    const oldPrices = priceList.querySelectorAll('compare-at-price, sale-price, discount-percentage');
    oldPrices.forEach(el => el.remove());

    if (hasPromotion) {
      const comparePrice = this.formatMoney(variant.compare_at_price);
      const salePrice = this.formatMoney(variant.price);
      const discountPercentage = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);

      priceList.innerHTML = `
        <compare-at-price unit-price="${variant.compare_at_price}" class="text-subdued line-through">
          <span class="sr-only">Preço normal</span>
          ${comparePrice}
        </compare-at-price>
        <discount-percentage class="text-on-sale text-sm">
          -${discountPercentage}%
        </discount-percentage>
        <sale-price class="text-on-sale">
          <span class="sr-only">Preço promocional</span>
          ${salePrice}
        </sale-price>
      `;
    } else {
      const price = this.formatMoney(variant.price);
      
      priceList.innerHTML = `
        <sale-price class="text-subdued">
          <span class="sr-only">Preço</span>
          ${price}
        </sale-price>
      `;
    }
  }

  updateBadges(productCard, variant, hasPromotion, swatch) {
    const badgeList = productCard.querySelector('.product-card__badge-list');
    if (!badgeList) return;

    const productAvailable = swatch.dataset.productAvailable === 'true';
    const productTags = (swatch.dataset.productTags || '').toLowerCase().split(',');
    const hasNewBadge = productTags.some(tag => tag.trim() === 'badge-new');
    const hasCustomPromoBadge = swatch.dataset.hasCustomPromo === 'true';

    const soldOutText = productCard.dataset.soldOutText || 'Esgotado';
    const onSaleText = productCard.dataset.onSaleText || 'Promo';

    const onSaleBadges = badgeList.querySelectorAll('on-sale-badge, .badge--on-sale');
    onSaleBadges.forEach(badge => badge.remove());

    const soldOutBadge = badgeList.querySelector('sold-out-badge, .badge--sold-out');
    if (soldOutBadge) soldOutBadge.remove();

    const existingCustomBadges = Array.from(badgeList.querySelectorAll('.badge--custom[data-promo-badge]'));
    existingCustomBadges.forEach(badge => badge.remove());

    if (!productAvailable && !hasNewBadge) {
      const soldOut = document.createElement('sold-out-badge');
      soldOut.className = 'badge badge--sold-out';
      soldOut.textContent = soldOutText;
      badgeList.insertBefore(soldOut, badgeList.firstChild);
      return;
    }

    if (hasPromotion && hasCustomPromoBadge) {
      const promoBadge = document.createElement('span');
      promoBadge.className = 'badge badge--custom';
      promoBadge.setAttribute('data-promo-badge', 'true');
      promoBadge.style.cssText = `color: ${swatch.dataset.promoBadgeTextColor}; background-color: ${swatch.dataset.promoBadgeBgColor};`;
      promoBadge.textContent = swatch.dataset.promoBadgeTitle;
      badgeList.insertBefore(promoBadge, badgeList.firstChild);
    } 
    else if (hasPromotion && !hasCustomPromoBadge) {
      const onSaleBadge = document.createElement('on-sale-badge');
      onSaleBadge.className = 'badge badge--on-sale';
      onSaleBadge.textContent = onSaleText;
      badgeList.insertBefore(onSaleBadge, badgeList.firstChild);
    }
  }

  update30DayPrice(productCard, hasPromotion, swatch) {
    const price30d = productCard.querySelector('.last-30d-price');
    if (!price30d) return;

    if (!hasPromotion) {
      price30d.style.display = 'none';
      return;
    }

    const campaignDiscount = parseFloat(swatch.dataset.campaignDiscount) || 0;
    const last30dDiscount = parseFloat(swatch.dataset.last30dDiscount) || 0;
    const baseMoney = parseFloat(swatch.dataset.baseMoney) || 0;
    const variantPrice = parseFloat(swatch.dataset.variantPrice) || 0;
    const variantComparePrice = parseFloat(swatch.dataset.variantComparePrice) || 0;
    
    const multiplier = parseFloat(price30d.dataset.multiplier) || 1.0;
    
    if (last30dDiscount <= 0) {
      price30d.style.display = 'none';
      return;
    }

    let priceInCents = null;

    if (last30dDiscount > campaignDiscount) {
      const baseShopifyCents = (variantComparePrice > variantPrice) ? variantComparePrice : variantPrice;
      const discountFactor = (100 - last30dDiscount) / 100;
      priceInCents = Math.round(baseShopifyCents * discountFactor);
    } else if (baseMoney > 0 && campaignDiscount > 0) {
      const baseCents = Math.round(baseMoney * 100);
      const marketCents = Math.round(baseCents * multiplier);
      
      const eurosFloor = Math.floor(marketCents / 100);
      const eurosFloorCents = eurosFloor * 100;
      const decimalCents = marketCents - eurosFloorCents;
      
      let fullPriceCents;
      if (decimalCents < 35) {
        fullPriceCents = eurosFloorCents;
      } else if (decimalCents < 70) {
        fullPriceCents = eurosFloorCents + 50;
      } else {
        fullPriceCents = eurosFloorCents + 100;
      }
      
      const discountFactor = (100 - campaignDiscount) / 100;
      priceInCents = Math.round(fullPriceCents * discountFactor);
    }

    if (priceInCents !== null) {
      const priceValueElement = price30d.querySelector('[data-price-value]');
      if (priceValueElement) {
        priceValueElement.textContent = this.formatMoney(priceInCents);
      }
      price30d.style.display = '';
    } else {
      price30d.style.display = 'none';
    }
  }

  formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    const formatString = (window.theme && window.theme.moneyFormat)
      || (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat)
      || '£{{amount}}';

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const match = formatString.match(placeholderRegex);
    if (!match) return formatString;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision != null ? precision : 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      const centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    let value = '';
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_no_decimals_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 0, "'");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductCardDynamicPricing();
  });
} else {
  new ProductCardDynamicPricing();
}
